
const DlgDisclosure = () => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="header-text fw-bold" style={{ fontSize: "30px"}}>DLG Disclosure</div>
            <table class="table table-striped table-bordered" style={{ width : "50%"}}>
                <thead>
                    <tr>
                        <th scope="col" style={{ width: '20px' }}>S.No</th>
                        <th scope="col" style={{ width: '200px' }}>Portfolio</th>
                        <th scope="col" style={{ width: '200px' }}>
                            Outstanding portfolio amount on <br /> 
                            which DLG has been offered (INR in Crores)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td scope="row">1</td>
                        <td>Partner1</td>
                        <td>25</td>
                    </tr>
                    <tr>
                        <td scope="row">2</td>
                        <td>Partner2</td>
                        <td>5.5</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
export default DlgDisclosure;